import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Button } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

interface PricesheetsTableProps {
  pricesheets: any[];
  onDelete: (product: any) => void;
}

const createLink = (pricesheet: any) => `/pricesheet/${pricesheet.id}`;

const PricesheetsTable: FC<PricesheetsTableProps> = (props) => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <TableContainer>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">Name</TableCell>
            <TableCell align="center">Scope</TableCell>
            <TableCell align="center">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.pricesheets?.map((pricesheet) => (
            <TableRow key={pricesheet.id}>
              <TableCell component="th" scope="row">
                {pricesheet.label}
              </TableCell>
              <TableCell align="center">{pricesheet.scope}</TableCell>
              <TableCell align="center">
                <Button onClick={() => {
                  history.push(createLink(pricesheet));
                }}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </Button>
                <Button onClick={() => {
                  props.onDelete(pricesheet);
                }}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PricesheetsTable;
